// extracted by mini-css-extract-plugin
export default {"label":"AttributeAssigner_label__kLE8M","container":"AttributeAssigner_container__S50Yy"};